export * from "ce/entities/DataTree/types";
import { ENTITY_TYPE as CE_ENTITY_TYPE } from "ce/entities/DataTree/types";

export type ENTITY_TYPE = CE_ENTITY_TYPE;

export const ENTITY_TYPE_VALUE = {
  ...CE_ENTITY_TYPE,
};
